/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './snack-message.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/snack-messages/snack-message/snack-message.component';
import * as i3 from '../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i4 from '@angular/material/core';
import * as i5 from '@angular/material/button';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '@angular/cdk/a11y';
import * as i8 from '@angular/material/tooltip';
import * as i9 from '@angular/cdk/overlay';
import * as i10 from '@angular/cdk/scrolling';
import * as i11 from '@angular/cdk/bidi';
import * as i12 from '@ngx-translate/core/src/translate.pipe';
import * as i13 from '@ngx-translate/core/src/translate.service';
import * as i14 from '@angular/flex-layout';
import * as i15 from '../../../../../$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory';
import * as i16 from '@angular/material/icon';
import * as i17 from '@angular/material/snack-bar';
const styles_SnackMessageComponent:any[] = [i0.styles];
export const RenderType_SnackMessageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SnackMessageComponent,data:{}});
export function View_SnackMessageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),
      12,'button',[['class','mr-1 mat-icon-button'],['color','danger'],['mat-button-sm',
          ''],['mat-icon-button','']],[[8,'disabled',0]],[[(null as any),'click'],
          [(null as any),'longpress'],[(null as any),'focus'],[(null as any),'blur'],
          [(null as any),'keydown'],[(null as any),'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.SnackMessageComponent = _v.component;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,6).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('focus' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,6).show()) !== false);
          ad = (pd_1 && ad);
        }
        if (('blur' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,6).hide(0)) !== false);
          ad = (pd_2 && ad);
        }
        if (('keydown' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,6)._handleKeydown($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('touchend' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,6).hide(1500)) !== false);
          ad = (pd_4 && ad);
        }
        if (('click' === en)) {
          const pd_5:any = ((<any>_co.onClose()) !== false);
          ad = (pd_5 && ad);
        }
        return ad;
      },i3.View_MatButton_0,i3.RenderType_MatButton)),i1.ɵdid(16384,(null as any),
      0,i4.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,
      (null as any),0,i5.MatButton,[i1.Renderer2,i1.ElementRef,i6.Platform,i7.FocusMonitor],
      {color:[0,'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i5.MatIconButtonCssMatStyler,
      ([] as any[]),(null as any),(null as any)),i1.ɵdid(147456,(null as any),0,i8.MatTooltip,
      [i1.Renderer2,i9.Overlay,i1.ElementRef,i10.ScrollDispatcher,i1.ViewContainerRef,
          i1.NgZone,i6.Platform,i7.AriaDescriber,i8.MAT_TOOLTIP_SCROLL_STRATEGY,[2,
              i11.Directionality]],{message:[0,'message']},(null as any)),i1.ɵpid(131072,
      i12.TranslatePipe,[i13.TranslateService,i1.ChangeDetectorRef]),i1.ɵdid(999424,
      (null as any),0,i14.ClassDirective,[i14.MediaMonitor,i1.ElementRef,i1.Renderer2,
          i1.Renderer,i1.IterableDiffers,i1.KeyValueDiffers,[8,(null as any)]],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),i1.ɵeld(0,
      (null as any),0,3,'mat-icon',[['class','mat-icon'],['role','img']],(null as any),
      (null as any),(null as any),i15.View_MatIcon_0,i15.RenderType_MatIcon)),i1.ɵdid(16384,
      (null as any),0,i4.MatPrefixRejector,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(638976,(null as any),0,i16.MatIcon,[i1.Renderer2,i1.ElementRef,i16.MatIconRegistry,
          [8,(null as any)]],(null as any),(null as any)),(_l()(),i1.ɵted(0,['close'])),
      (_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),['\n   \n  ','\n'])),
      i1.ɵpid(131072,i12.TranslatePipe,[i13.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    const currVal_1:any = 'danger';
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,6,0,i1.ɵnov(_v,7).transform('CLOSE')),
        '');
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = 'mr-1';
    _ck(_v,8,0,currVal_3);
    _ck(_v,12,0);
  },(_ck,_v) => {
    var _co:i2.SnackMessageComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,4).disabled || (null as any));
    _ck(_v,2,0,currVal_0);
    const currVal_4:any = i1.ɵunv(_v,15,0,i1.ɵnov(_v,16).transform(_co.snackMessage.message));
    _ck(_v,15,0,currVal_4);
  });
}
export function View_SnackMessageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-snack-message',
      ([] as any[]),(null as any),(null as any),(null as any),View_SnackMessageComponent_0,
      RenderType_SnackMessageComponent)),i1.ɵdid(114688,(null as any),0,i2.SnackMessageComponent,
      [i17.MatSnackBarRef,i17.MAT_SNACK_BAR_DATA],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SnackMessageComponentNgFactory:i1.ComponentFactory<i2.SnackMessageComponent> = i1.ɵccf('app-snack-message',
    i2.SnackMessageComponent,View_SnackMessageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvc25hY2stbWVzc2FnZXMvc25hY2stbWVzc2FnZS9zbmFjay1tZXNzYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvY2hyb25vY2FzaFYzL3N2YS93ZWJhcHAtY2xrL3NyYy9hcHAvc2hhcmVkL3NuYWNrLW1lc3NhZ2VzL3NuYWNrLW1lc3NhZ2Uvc25hY2stbWVzc2FnZS5jb21wb25lbnQudHMiLCJuZzovLy92YXIvY2hyb25vY2FzaFYzL3N2YS93ZWJhcHAtY2xrL3NyYy9hcHAvc2hhcmVkL3NuYWNrLW1lc3NhZ2VzL3NuYWNrLW1lc3NhZ2Uvc25hY2stbWVzc2FnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvc25hY2stbWVzc2FnZXMvc25hY2stbWVzc2FnZS9zbmFjay1tZXNzYWdlLmNvbXBvbmVudC50cy5TbmFja01lc3NhZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PlxuICA8YnV0dG9uIG1hdC1pY29uLWJ1dHRvblxuICAgICAgICAgIG1hdC1idXR0b24tc20gY29sb3I9XCJkYW5nZXJcIlxuICAgICAgICAgIGNsYXNzPVwibXItMVwiXG4gICAgICAgICAgbWF0VG9vbHRpcD1cInt7ICdDTE9TRScgfCB0cmFuc2xhdGUgfX1cIlxuICAgICAgICAgIChjbGljayk9XCJvbkNsb3NlKClcIj5cbiAgICA8bWF0LWljb24+Y2xvc2U8L21hdC1pY29uPlxuICA8L2J1dHRvbj5cbiAgJm5ic3A7XG4gIHt7c25hY2tNZXNzYWdlLm1lc3NhZ2UgfCB0cmFuc2xhdGV9fVxuPC9kaXY+XG4iLCI8YXBwLXNuYWNrLW1lc3NhZ2U+PC9hcHAtc25hY2stbWVzc2FnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBSzthQUFBLDBCQUNIO01BQUE7VUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUlRO1VBQUE7VUFBQTtRQUFBO1FBSlI7TUFBQSx1REFBQTtNQUFBLHlFQUFBO01BQUE7TUFBQSwwQ0FBQTtNQUFBLGtEQUFBO01BQUE7Z0ZBQUE7Z0NBQUEsaURBR1E7d0JBQUEsb0RBSFI7TUFBQTs0REFBQTtVQUFBLDZCQUk0QiwrQkFDMUI7TUFBQTtNQUFBLCtFQUFBO01BQUE7YUFBQTtVQUFBLGdEQUFVO01BQWdCLDZCQUNuQjthQUFBO01BR0w7SUFSa0I7SUFEdEIsV0FDc0IsU0FEdEI7SUFHUTtRQUFBO0lBSFIsV0FHUSxTQUhSO0lBRVE7SUFGUixXQUVRLFNBRlI7SUFLRTs7O0lBTEY7SUFBQSxXQUFBLFNBQUE7SUFNUztJQUFBOzs7O29CQ1BYO01BQUE7c0NBQUEsVUFBQTtNQUFBOztJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/snack-messages/snack-message/snack-message.component.ngfactory.ts